






















































import { AxiosResponse } from "axios";
import Vue from "vue";
import Item from "../components/Item.vue";
import { itemApi } from "../utils/axios";

export default Vue.extend({
  name: "Home",

  components: {
    Item
  },
  data: () => ({
    items: [],
    activeBtn: 1,
    slides: ["First", "Second", "Third", "Fourth", "Fifth"]
  }),
  mounted() {
    // 초기 페이지 값과 필터 데이터를 저장합니다.
    const InitialFilter = {status: false, category: [], grade: [], si: null, gu: null, name:""}
    sessionStorage.setItem("page", String(1));
    sessionStorage.setItem("filters", JSON.stringify(InitialFilter));
    this.$store.state.auctionModule.filters = InitialFilter;

    itemApi.getItemPage(1, InitialFilter).then((res:AxiosResponse) => {
      this.items = res.data.object
    })
  },
});
